module.exports = __webpack_public_path__ + "static/media/avatar_39.dd1390ba.svg";